/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description
 */

import { safeFilterActions } from '@zcode/utils'
import { detail as rootReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export { whitelist }
export const detail = safeFilterActions(rootReducer, whitelist)
